import React from "react";
import PropTypes from "prop-types";
import { Avatar } from "@mui/material";

import { styles } from "./ImageOrInitialsStyles";

const ImageOrInitials = ({
  image,
  text,
  customStyles,
  useFirstWordInitial,
  showSquareImage,
}) => {
  const avatarLabel = text ? `${text} profile image` : "Provider profile image";

  return (
    <>
      {image ? (
        <Avatar
          alt={avatarLabel}
          src={image}
          sx={{
            ...styles.imageDimension,
            ...(showSquareImage ? styles.squareImageStyles : {}),
            ...customStyles,
          }}
        />
      ) : (
        <Avatar
          aria-label={text ? `${text} initials avatar` : "Provider initials avatar"}
          sx={{
            ...styles.noImageBackground,
            ...styles.imageDimension,
            ...(showSquareImage ? styles.squareImageStyles : {}),
            ...customStyles,
          }}
        >
          {useFirstWordInitial
            ? text?.trim()?.charAt(0).toUpperCase()
            : (text?.trim()?.split(" ")[1] || text?.split(" ")[0] || "")
                .charAt(0)
                .toUpperCase()}
        </Avatar>
      )}
    </>
  );
};

ImageOrInitials.propTypes = {
  showSquareImage: PropTypes.bool,
  image: PropTypes.string,
  text: PropTypes.string,
  useFirstWordInitial: PropTypes.bool,
  customStyles: PropTypes.object,
};

export default ImageOrInitials;
